import { MatchSocketRepository } from "../repositories/SocketRepository";

export class DisconnectSocketMatch {
	constructor(private repository: MatchSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.disconnectSocket();
	}
}
